// extracted by mini-css-extract-plugin
export default {"emojiButton":"emojiButton__JpdDA"};